// extracted by mini-css-extract-plugin
export default {"select":"src-pages-ProductEditor-VirtualProduct-SalesChannelUsage-css-module__select--SaDgo"};